export const GET_AUTENTICACION_LOADING = 'autenticacion/GET_AUTENTICACION_LOADING';
export const GET_AUTENTICACION_SUCCESS = 'autenticacion/GET_AUTENTICACION_SUCCESS';
export const GET_AUTENTICACION_FAILURE = 'autenticacion/GET_AUTENTICACION_FAILURE';

export const GET_ESTADOS_LOADING = 'autenticacion/GET_ESTADOS_LOADING';
export const GET_ESTADOS_SUCCESS = 'autenticacion/GET_ESTADOS_SUCCESS';
export const GET_ESTADOS_FAILURE = 'autenticacion/GET_ESTADOS_FAILURE';

export const GET_INDICADORES_LOADING = 'autenticacion/GET_INDICADORES_LOADING';
export const GET_INDICADORES_SUCCESS = 'autenticacion/GET_INDICADORES_SUCCESS';
export const GET_INDICADORES_FAILURE = 'autenticacion/GET_INDICADORES_FAILURE';

export const GET_CAPTCHA_LOADING = 'autenticacion/GET_CAPTCHA_LOADING';
export const GET_CAPTCHA_SUCCESS = 'autenticacion/GET_CAPTCHA_SUCCESS';
export const GET_CAPTCHA_FAILURE = 'autenticacion/GET_CAPTCHA_FAILURE';

export const GET_CERRAR_SESION_LOADING = 'autenticacion/GET_CERRAR_SESION_LOADING';
export const GET_CERRAR_SESION_SUCCESS = 'autenticacion/GET_CERRAR_SESION_SUCCESS';
export const GET_CERRAR_SESION_FAILURE = 'autenticacion/GET_CERRAR_SESION_FAILURE';

export const GET_MENU_SISTEMAS_LOADING = 'autenticacion/GET_MENU_SISTEMAS_LOADING';
export const GET_MENU_SISTEMAS_SUCCESS = 'autenticacion/GET_MENU_SISTEMAS_SUCCESS';
export const GET_MENU_SISTEMAS_FAILURE = 'autenticacion/GET_MENU_SISTEMAS_FAILURE';
